import Clarity from "@microsoft/clarity";
import { useEffect } from "react";

export function ClarityProvider() {
	useEffect(() => {
		if (typeof window !== "undefined") {
			const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID || "";
			if (projectId) {
				Clarity.init(projectId);
			}
		}
	}, []);

	return null;
}
